import { createFileRoute } from "@tanstack/react-router";
import { AdminProfilePage } from "@/projects/admin/pages/ProfilePage";

export const Route = createFileRoute("/admin/profile")({
  head: () => ({ meta: [{ title: "Profile — Admin" }] }),
  component: AdminProfilePage,
});
